import { styled } from 'styled-components'
import Card from './Card'
import { interactiveHover } from './mixins/interactive'

const InteractiveCard = styled(Card)`
  ${interactiveHover}
`

export default InteractiveCard
